import React from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';

// HELP
import LeftSection from './help/LeftSection/LeftSection';
import RightSection from './help/RightSection/RightSection';

// STYLES
import { WelcomeContainer } from './styles';

const Welcome = () => {
  const partner = useSelector(state => state.partner.data || {});

  return (
    <WelcomeContainer className="section welcome">
      <div className="page-content">
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} md={6}>
            <LeftSection partner={partner} />
          </Grid>
          <Grid item sm={12} md={6}>
            <RightSection />
          </Grid>
        </Grid>
      </div>
    </WelcomeContainer>
  );
};

export default React.memo(Welcome);
